import React from 'react';
import { Button, Container } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

const NotFound = ()=>{
    let history = useHistory();
    
    return (
        <Container fluid className='vh-100 d-flex w-100 bg-light justify-content-center'>
            <div className='text-center align-self-center' >
                <i className='material-icons text-danger' style={{fontSize: 60}}>cancel</i>
                <h1>- 404 -</h1>
                <h1>NOT FOUND</h1>
                <Button variant='success font-weight-bold' className='my-1' onClick={()=>history.push('/')}>Back</Button>
            </div>
        </Container>
    )
}

export default NotFound;